<template>
	<div id="sidebar-container" class="sidebar-expanded">
		<div class="logo fixed-navbar-logo">
			<router-link :to="{ name : 'ResumenNegocio' }">
				<img :src="require('@/assets/images/Logo vector.svg')" class="sidebar-logo" alt="Logo">
			</router-link>
			<div class="barrita"></div>
		</div>
    <div class="bottom-menu">
			<a href="#" class="" @click.prevent="SidebarCollapse()">
				<i class="material-icons chevron-right">chevron_right</i>
				<i class="material-icons chevron-left">chevron_left</i>
			</a>
		</div>
    <ul class="list-group noselect">
      <li class="list-group-item sidebar-separator-title text-muted d-flex align-items-center menu-collapsed">
          <small>Leasing NC</small>
      </li>
			<div v-for="(i, index) in items" v-bind:key="index" class="list-group-module">
				<router-link :to="{ name: i.enlace }" class="list-group-item list-group-item-action" v-if="i.submenu==='0'">
          <span class="material-icons" v-if="!getMenuIcon(i)">{{i.icon}}</span>
          <img v-else :src="getMenuIcon(i)" class="sidebar-icon" :alt="i.menu">
          <span class="menu-collapsed" v-if="!collapsemenu">
            {{i.menu}}
          </span>
				</router-link>
				<a class="list-group-item list-group-item-action btn-administracion" :class="{'active':i.menu===menu}" @click="showSubmenu(i.menu)" v-else>
						<span class="material-icons" v-if="!getMenuIcon(i)">{{i.icon}}</span>
						<img v-else :src="getMenuIcon(i)" class="sidebar-icon" :alt="i.menu">
						<span class="menu-collapsed" v-if="!collapsemenu">
							{{i.menu}}
						</span>
				</a>
				<div class="box-submenus" :class="{'collapsed':i.menu===menu && submenu===1}">
					<div class="box-submenu" v-for="(s, index) in items2" v-bind:key="s.menu+'-'+index" >
						<router-link :to="{ name: s.enlace}" class="list-group-item list-group-item-action" v-show="s.menu===i.menu && i.menu===menu && submenu===1">
              <span>
                {{s.submenu}}
              </span>
						</router-link>
					</div>
				</div>
			</div>
    </ul>
	</div>
</template>
<script>
import $ from 'jquery'
import { mapState, mapActions } from 'vuex'
import ComercialIcon from '@/assets/images/ico-svg/Comercial.svg'
import AdministracionIcon from '@/assets/images/ico-svg/Administración.svg'
import InformesIcon from '@/assets/images/ico-svg/Informes.svg'
import FacturacionIcon from '@/assets/images/ico-svg/Facturación.svg'
import PagosIcon from '@/assets/images/ico-svg/Pagos.svg'
import RiesgoIcon from '@/assets/images/ico-svg/Riesgo - Co..svg'
import MultipagoIcon from '@/assets/images/ico-svg/Multipago.svg'
import InventarioIcon from '@/assets/images/ico-svg/Inventario.svg'

export default {
	name: 'Sidebar',
	methods: {
		...mapActions(['doSearchmenu', 'doCollapsemenu', 'doRoles', 'doMenu']),
		/**
		 * Obtiene el icono SVG correspondiente para un item del menú del sidebar.
		 * Busca coincidencias exactas primero y luego busca coincidencias parciales
		 * en el nombre del menú para determinar qué icono mostrar.
		 *
		 * @param {Object} menuItem - El objeto del item del menú que contiene la propiedad 'menu'
		 * @returns {String|null} - La ruta del icono SVG o null si no se encuentra coincidencia
		 */
		getMenuIcon (menuItem) {
			if (!menuItem || !menuItem.menu) {
				return null
			}
			const menuName = String(menuItem.menu).trim().toLowerCase()

			// Icon mapping: key is the menu name (lowercase), value is the icon
			const iconMap = {
				'comercial': this.ComercialIcon,
				'administración': this.AdministracionIcon,
				'administracion': this.AdministracionIcon,
				'informes': this.InformesIcon,
				'facturación': this.FacturacionIcon,
				'facturacion': this.FacturacionIcon,
				'pagos': this.PagosIcon,
				'riesgo': this.RiesgoIcon,
				'multipago': this.MultipagoIcon,
				'inventario': this.InventarioIcon
			}

			// Direct match first
			if (iconMap[menuName]) {
				return iconMap[menuName]
			}

			// Fallback: check if menu name contains any of the keys
			for (const key in iconMap) {
				if (menuName.includes(key)) {
					return iconMap[key]
				}
			}

			return null
		},
		SidebarCollapse () {
			// $('.menu-collapsed').toggleClass('d-none')
			$('.sidebar-submenu').toggleClass('d-none')
			$('.submenu-icon').toggleClass('d-none')
			$('#sidebar-container').toggleClass('sidebar-expanded sidebar-collapsed')

			// Treating d-flex/d-none on separators with title
			var SeparatorTitle = $('.sidebar-separator-title')
			if (SeparatorTitle.hasClass('d-flex')) {
				SeparatorTitle.removeClass('d-flex')
				this.doCollapsemenu(true)

				// $('.opcionesSubMenu').removeClass('ml-4')
			} else {
				SeparatorTitle.addClass('d-flex')
				this.doCollapsemenu(false)

				// $('.opcionesSubMenu').addClass('ml-4')
			}

			// Collapse/Expand icon
			$('#collapse-icon').toggleClass('fa-angle-double-left fa-bars')
		},
		toggleMenuForm () {
			$('#sidebar-container-formulario').toggleClass('d-md-block sidebar-expanded sidebar-form-collapsed')
		},
		showForm () {
			let buttoniconsclass = 'chevron_left'

			if (this.searchmenu) {
				this.doSearchmenu(false)

				buttoniconsclass = 'chevron_right'
			} else {
				this.doSearchmenu(true)
			}

			$('#boton-expande2').find('i').html(buttoniconsclass)
		},
		showSubmenu (menu) {
			if (this.menu !== menu) {
				this.submenu = 0
				this.menu = menu
				this.showSubmenu(menu)
				return false
			}

			this.menu = menu
			if (this.submenu === 0) { this.submenu = 1 } else { this.submenu = 0 }
		},
		getRolesMenu () {
			const auth = {
				headers: { 'Authorization': this.accessToken }
			}
			this.isLoading = true
			this.axios.post(this.apiurl + 'RolesPermisos/getRolesMenu', {
				idPais: this.pais.code
			}, auth).then(response => {
				this.isLoading = false
				if (response.data.result) {
					this.doRoles(response.data.roles)
					this.doMenu(response.data.menu)
					this.setMenu()
				}
			}).catch(error => {
				this.isLoading = false
				console.log(error.response)
			})
		},
		setMenu () {
			this.items = []
			this.items2 = []
			var add = 0
			this.accessMenu.forEach((value, key) => {
				this.items.forEach((value1, key) => {
					if (value1.menu === value.menu) { add = 1 }
				})
				// Omitir menu cobranza provisorio (Se debe refactorizar a nivel de BD)
				if (value.tipo === 1 && add === 0 && value.menu !== 'Cobranza') { this.items.push({ menu: value.menu, enlace: value.enlace, submenu: value.submenu, icon: value.fa_icon }) }
				add = 0
			})
			this.accessMenu.forEach((value, key) => {
				if (value.submenu.length > 1) { this.items2.push({ menu: value.menu, submenu: value.submenu, enlace: value.enlace, icon: value.fa_icon_p }) }
			})
		}
	},
	ready: function () {
	},
	mounted () {
		$('#body-row .collapse').show('slow')
		// Collapse/Expand icon
		$('#collapse-icon').addClass('fa-angle-double-left')
		this.SidebarCollapse()
		this.toggleMenuForm()
		this.showForm()
		this.setMenu()
	},
	data () {
		return {
			// Note 'isActive' is left out and will not appear in the rendered table
			iscollapse: true,
			submenu: 0,
			items: [],
			items2: [],
			menu: '',
			ComercialIcon: ComercialIcon,
			AdministracionIcon: (typeof AdministracionIcon === 'object' && AdministracionIcon.default) ? AdministracionIcon.default : AdministracionIcon,
			InformesIcon: (typeof InformesIcon === 'object' && InformesIcon.default) ? InformesIcon.default : InformesIcon,
			FacturacionIcon: (typeof FacturacionIcon === 'object' && FacturacionIcon.default) ? FacturacionIcon.default : FacturacionIcon,
			PagosIcon: (typeof PagosIcon === 'object' && PagosIcon.default) ? PagosIcon.default : PagosIcon,
			RiesgoIcon: (typeof RiesgoIcon === 'object' && RiesgoIcon.default) ? RiesgoIcon.default : RiesgoIcon,
			MultipagoIcon: (typeof MultipagoIcon === 'object' && MultipagoIcon.default) ? MultipagoIcon.default : MultipagoIcon,
			InventarioIcon: (typeof InventarioIcon === 'object' && InventarioIcon.default) ? InventarioIcon.default : InventarioIcon
		}
	},
	computed: {
		...mapState([
			'accessToken',
			'searchmenu', 'filter', 'collapsemenu', 'accessMenu', 'pais', 'apiurl'])
	},
	watch: {
		$route (to, from) {
			if ($('#body-row').hasClass('collapsemenu')) {
				this.showSubmenu(null)
			}
		},
		pais: function (val) {
			if (val) {
				this.getRolesMenu()
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue